"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_analytics_1 = require("owa-analytics");
var folderIdToName_1 = require("owa-session-store/lib/utils/folderIdToName");
var owa_mail_list_store_1 = require("owa-mail-list-store");
function getSortColumnToLog(tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var sortColumn = null;
    if (tableView) {
        var isSortBySupported = tableView.tableQuery.type == 0 /* Folder */ ||
            tableView.tableQuery.type == 2 /* Group */;
        sortColumn = isSortBySupported ? owa_mail_list_store_1.getSortByForTable(tableView).sortColumn : null;
    }
    return sortColumn;
}
exports.default = {
    blockSendersFromTableDatapoint: {
        datapoint: {
            name: 'TnS_BlockSendersFromListView',
            customData: function (rowKeys, tableView, actionSource) { return [actionSource, rowKeys.length, tableView.tableQuery.type]; },
        },
    },
    blockSenderFromReadingPaneDatapoint: {
        datapoint: {
            name: 'TnS_BlockSenderFromReadingPane',
        },
    },
    setConversationsFlagStateDatapoint: { datapoint: { name: 'TnS_FlagConversation' } },
    setItemsFlagStateDatapoint: { datapoint: { name: 'TnS_FlagItems' } },
    archiveMailListRowsDatapoint: {
        datapoint: {
            name: 'TnS_ArchiveMailListRows',
            customData: function (rowKeys, tableView, actionSource) { return [
                actionSource,
                rowKeys.length,
                tableView.tableQuery.type,
                tableView.tableQuery.listViewType,
            ]; },
        },
    },
    deleteConversationDatapoint: {
        datapoint: {
            name: 'TnS_DeleteConversation',
            options: { isQos: true },
            customData: function (conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource) { return [
                actionSource,
                conversationActionContexts.length,
                disposalType,
                getSortColumnToLog(originalTableViewId),
            ]; },
        },
    },
    deleteItemsDatapoint: {
        datapoint: {
            name: 'TnS_DeleteItem',
            options: { isQos: true },
            customData: function (itemIds, disposalType, parentFolderId, actionSource, requestInitOptions) { return [actionSource, itemIds.length, disposalType]; },
        },
    },
    deleteItemsFromTableDatapoint: {
        datapoint: {
            name: 'TnS_DeleteItemsFromTable',
            customData: function (itemRowKeys, tableViewId, actionSource) { return [actionSource, itemRowKeys.length, getSortColumnToLog(tableViewId)]; },
        },
    },
    markItemsJunkNotJunkDatapoint: {
        datapoint: {
            name: 'TnS_JunkItem',
            customData: function (itemIds, isJunkValueToSet, actionSource) { return [actionSource, itemIds.length, isJunkValueToSet]; },
        },
    },
    markItemsAsPhishingDatapoint: {
        datapoint: {
            name: 'TnS_PhishItem',
            customData: function (itemIds, parentFolderId, actionSource) { return [actionSource, itemIds.length]; },
        },
    },
    moveConversationDatapoint: {
        datapoint: {
            name: 'TnS_MoveConversation',
            customData: function (rowKeys, destinationFolderId, originalTableView, actionSource) { return [
                actionSource,
                originalTableView.tableQuery.type,
                originalTableView.tableQuery.folderId // folderId is null in search
                    ? folderIdToName_1.default(originalTableView.tableQuery.folderId)
                    : null,
                folderIdToName_1.default(destinationFolderId),
                rowKeys.length,
            ]; },
            options: function (rowKeys, destinationFolderId, originalTableView, actionSource) {
                return {
                    variant: actionSource == 'NonUserAction'
                        ? owa_analytics_1.DatapointVariant.None // Do not log the datapoint if it's not user triggered
                        : owa_analytics_1.DatapointVariant.Both,
                };
            },
        },
    },
    moveItemsDatapoint: {
        datapoint: {
            name: 'TnS_MoveItem',
            customData: function (rowKeys, destinationFolderId, originalTableView, actionSource) { return [
                actionSource,
                originalTableView.tableQuery.type,
                originalTableView.tableQuery.folderId // folderId is null in search
                    ? folderIdToName_1.default(originalTableView.tableQuery.folderId)
                    : null,
                folderIdToName_1.default(destinationFolderId),
                rowKeys.length,
            ]; },
            options: function (rowKeys, destinationFolderId, originalTableView, actionSource) {
                return {
                    variant: actionSource == 'NonUserAction'
                        ? owa_analytics_1.DatapointVariant.None // Do not log the datapoint if it's not user triggered
                        : owa_analytics_1.DatapointVariant.Both,
                };
            },
        },
    },
    restoreConversationDatapoint: { datapoint: { name: 'TnS_RestoreConversation' } },
    unsubscribeDatapoint: {
        datapoint: {
            name: 'TnS_Unsubscribe',
            customData: function (message, originalTableView, isTrustedUnsubscribe, actionSource) { return [actionSource, isTrustedUnsubscribe]; },
        },
    },
    emptyFolderDatapoint: { datapoint: { name: 'TnS_EmptyFolder' } },
    optOutDatapoint: { datapoint: { name: 'TnS_OptOut' } },
    pinConversationsDatapoint: {
        datapoint: {
            name: 'TnS_PinConversations',
            customData: function (conversationRowKeys, tableView, shouldMarkAsPinned, actionSource) { return [actionSource, shouldMarkAsPinned, conversationRowKeys.length]; },
        },
    },
    pinItemsDatapoint: {
        datapoint: {
            name: 'TnS_PinItems',
            customData: function (rowKeys, tableView, shouldMarkAsPinned, actionSource) { return [actionSource, shouldMarkAsPinned, rowKeys.length]; },
        },
    },
    moveConversationToFocusedOrOther: {
        datapoint: {
            name: 'TnS_MoveConversationToFocusedOrOther',
            customData: function (conversationRowKeys, tableViewId, actionSource) { return [
                actionSource,
                conversationRowKeys.length,
                owa_mail_list_store_1.getFocusedFilterForTable(owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId)),
            ]; },
        },
    },
    alwaysMoveRowToFocusedOrOtherDatapoint: {
        datapoint: {
            name: 'TnS_AlwaysMoveRowToFocusedOrOther',
            customData: function (rowKeys, tableView, actionSource) { return [actionSource, owa_mail_list_store_1.getFocusedFilterForTable(tableView)]; },
        },
    },
    addCategories: {
        datapoint: {
            name: 'Triage_AddCategories',
            customData: function (rowKeys, tableViewId, categoriesToAdd, actionSource) { return [actionSource, rowKeys.length]; },
        },
    },
    removeCategories: {
        datapoint: {
            name: 'Triage_RemoveCategories',
            customData: function (rowKeys, tableViewId, categoriesToRemove, actionSource) { return [actionSource, rowKeys.length]; },
        },
    },
    clearCategories: {
        datapoint: {
            name: 'Triage_ClearCategories',
            customData: function (rowKeys, tableViewId, actionSource) { return [actionSource, rowKeys.length]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/datapoints.js
// module id = 2625
// module chunks = 62